import React, { useEffect, useState } from 'react'
import API from '../../services/api'
import { Modal } from 'react-bootstrap';
import { roles } from '../../utils/constants';
import { SlOption, SlSelect, SlDrawer, SlButton, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';


function CompanyDetails(props) {
    const [companyDetails, setCompanyDetails] = useState([])
    const fetchCompanyDetails = async() =>{
        try {
            let res = await API({
                url:'/order/company-details',
                method:'POST',
                responseType:'json',
                data:{
                    company_id : props.company_id
                }
            })
            if(res.code === 200){
                setCompanyDetails(res.data)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const updateCompanyStatus = async(verified_status) => {
      try {
        let res = await API({
          url:'/user/company/update_verified_status',
          method:'POST',
          responseType:'json',
          data:{
              company_id : props.company_id,
              verified_status
          }
      })
      if(res.code === 200){
          props.setShow(false)
          if(props.refresh !== undefined){
            props.setRefresh(!props.refresh)
          }
      }
      } catch (error) {
        console.error("Error @ updateCompanyStatus", error)
      }
    }

    const handleClose = ()=>{
        props.setShow(false)
    }

    useEffect(()=>{
        if(props.company_id){
          // console.log("inside the useEffect")
            fetchCompanyDetails()
        }
    }, [props.company_id])
  return (
    <div>
         <Modal show={props.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Company Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {companyDetails.length > 0 ? <><div className=''>
            <div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>Company Name</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].company_name}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>Billing Name</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].billing_name}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>Billing Mobile</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].billing_mobile}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>Billing Email</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].billing_email}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>GST No.</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].gst_no || "-"}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>PAN No.</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].pan_no || "-"}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>Account No.</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].account_num || "-"}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>IFSC Code</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].ifsc || "-"}</div>
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>Address</span><span>:</span></p>
                  <div className='mb-2 ml-2 whitespace-break-spaces w-[250px]'>{companyDetails[0].address || "-"}</div>  
                </div>
                <div className='d-flex justify-start mb-2'>
                  <p className='w-[200px] d-flex justify-content-between'><span>IsAgency</span><span>:</span></p>
                  <div className='mb-2 ml-2'>{companyDetails[0].isagency ? "YES" : "NO"}</div>
                </div>
                {(localStorage.getItem('role') === roles.financer || localStorage.getItem('role') === roles.ops) && (
                  <div className='d-flex justify-start mb-2'>
                    <p className='w-[200px] d-flex justify-content-between'><span>Status</span><span>:</span></p>
                    <div className='mb-2 ml-2'>{companyDetails[0].verified_status === 1 ? "Verified" : companyDetails[0].verified_status === 2 ? "Not Verified" : "Rejected"}</div>
                  </div>
                )}
              </div>

          </div>
          {localStorage.getItem('role') === roles.financer && props.refresh !== undefined && (companyDetails[0].verified_status === 2 || companyDetails[0].verified_status === 3) &&  <div className='d-flex justify-around'>
                <SlButton
                  type="submit"
                  variant="danger"
                  size="small"
                  className='w-48'
                  onClick={(e) => {updateCompanyStatus(3)}}>Reject</SlButton>
                <SlButton
                  type="submit"
                  variant="success"
                  size="small"
                  className='w-48'
                  onClick={(e) => {updateCompanyStatus(1)}}>Approve</SlButton>
              </div>} </>: null}
        </Modal.Body>
      </Modal> 
    </div>
  )
}

export default CompanyDetails